import {
    serverBus
} from '@/main'
import FolderApi from '@/scripts/api/folder.api'
import SessionManager from '@/Manager/Session.manager'
import KeyboardManager from '@/Manager/keyboard.manager'
import Global from '@/scripts/Global'
import FileApi from '@/scripts/api/file.api';
import FileDetails from '@/components/RightSidebar/FileDetails/FileDetails.vue';
import DragAndDropMention from '@/scripts/mixins/DragAndDropMention.js';
import {
    Channel
} from '@/classes/Channel'
import {
    Logging
} from '@/scripts/Logging';
import VueSignals from '@/scripts/VueSignals';
import config from '@/scripts/config';

let bulkOperation = false
export default {
    name: 'FolderContent',
    data() {
        return {
            rightSidebarTheme: 'folder_content',
            ActiveChannelDoc: SessionManager.getActiveChannel(),
            viewFolderContent: [],
            rootFolderContent: [],
            tempFolderContent: [],
            activeChannelId: SessionManager.getActiveChannelId(),
            activeFolderName: SessionManager.getActiveChannel().channel_name,
            hover: false,
            subfolder: false,
            mainSpinner: false,
            createNewFolder: false,
            newFolderName: '',
            errorMessage: '',
            showContextMenu: '',
            lsError: true,
            showFileId: '',
            fileDoc: null,
            activatedView: 'Chat',
            lastActivatedChannelId: '',
            folderTreeObjects: [],
            userRights: [],
            skip: 0,
            loading: false,
            endOfContent: false,
            endOfRootContent: false,
            rootSkip: 0,
            ContextMenuBottom: false,
            ContextMenuTop: false,
            scrolledLength: 0,
            stopPoint: 0,
            bulkOperation: false,
            showLongFolderName: false,
            bulkOperationsQueue: Array(),
            bulkSelectedIds: Array(),
            moveContextMenu: 0,
            parentDocs: [],
            draggedItem: null,
            screenWidth: window.innerWidth
        }
    },
    filters: {
        formatName(name) {
            if (window.innerWidth <= 345) {
                return name.length > 25 ? name.slice(0, 25) + '..' : name;
            } else {
                return name.length > 30 ? name.slice(0, 30) + '..' : name;
            }
        }
    },
    watch: {
        viewFolderContent(value) {
            Global.setFoldeContent(value);
        }
    },
    mixins: [DragAndDropMention],
    components: {
        FileDetails,
    },
    mounted() {
        this.showFileId = ''
        /// Globalize the currrent view
        if (typeof sessionStorage.getItem(VueSignals.ACTIVATED_VIEW) != 'undefined' && sessionStorage.getItem(VueSignals.ACTIVATED_VIEW) != null) {
            SessionManager.setView(sessionStorage.getItem(VueSignals.ACTIVATED_VIEW))
        }
        this.activatedView = SessionManager.getView()

        serverBus.$on(VueSignals.HIDE_CONTEXT_MENU, (success) => {
            this.showFileId = ''
        })

        serverBus.$on(VueSignals.RIGHT_SIDEBAR_THEME, (theme) => {
            this.rightSidebarTheme = theme
        })

        serverBus.$on(VueSignals.CREATE_FOLDER, (name) => {
            this.newFolderName = name
            this.createFolder()
        })

        serverBus.$on(VueSignals.DELETE_FF, (ff_id) => {
            this.Delete(ff_id)
        })

        serverBus.$on(VueSignals.RENAME_FF, (data) => {
            this.Rename(data)
        })

        serverBus.$on(VueSignals.HIDE_CONTEXT_MENU, (data) => {
            this.showContextMenu = ''
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_PARENT_DOCS, (parent_docs) => {
            this.parentDocs = parent_docs
            this.subfolder = true
            this.folderTreeObjects = parent_docs.reverse()
        })

        serverBus.$on(VueSignals.ACTIVE_POSSIBLE_CHANGED, (ch_id) => {
            this.newFolderName = ''
            this.createNewFolder = false
            this.ActiveChannelDoc = SessionManager.getActiveChannel()
            this.viewFolderContent = []
            this.activeChannelId = this.ActiveChannelDoc.channel_id
            this.activeFolderName = SessionManager.getActiveChannel().channel_name
            this.subfolder = false
            this.lsError = true
            this.errorMessage = ''
            this.skip = 0
            this.rootSkip = 0
            this.bulkOperationsQueue = []
            this.bulkSelectedIds = []
            this.parentDocs = []
            this.ListContent(this.ActiveChannelDoc.channel_id, 0)
        })

        serverBus.$on(VueSignals.CHANNEL_CONTENT_CHANGED, (file_id) => {
            this.ListContent(this.activeChannelId, 0, file_id)
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (success) => {
            this.newFolderName = ''
            this.createNewFolder = false
            this.ActiveChannelDoc = SessionManager.getActiveChannel()
            this.viewFolderContent = []
            this.activeChannelId = this.ActiveChannelDoc.channel_id
            this.activeFolderName = SessionManager.getActiveChannel().channel_name
            this.subfolder = false
            this.lsError = true
            this.fileDoc = null
            this.skip = 0
            this.rootSkip = 0
            this.bulkOperationsQueue = []
            this.bulkSelectedIds = []
            this.parentDocs = []
            this.errorMessage = ''
            Global.globalValue(VueSignals.ACTIVATED_VIEW, 'Chat')
        })


        serverBus.$on(VueSignals.SHOW_MENTION_DETAILS, (data) => {
            if (data.type == "file" || data.type == "folder") {
                Global.globalValue(VueSignals.RIGHT_SIDEBAR_THEME, 'folder_content')
                let ff_elem = this.viewFolderContent.find(currElem => {
                    return currElem.cp_id == data.data_id
                })
                if (typeof ff_elem == 'undefined') {
                    this.mainSpinner = true
                    if (data.type == "file") {
                        FileApi.Details(data.data_id, this.ActiveChannelDoc.channel_id).then(res => {
                            if (res.data.result) {
                                ff_elem = res.data
                                this.FileViewDetails(ff_elem)
                                this.mainSpinner = false
                            } else {
                                if (res.data.reason == "file_not_found") {
                                    this.errorMessage = "File is not found"
                                }
                                setTimeout(function() {
                                    Global.globalValue(VueSignals.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR, true)
                                }, 3000)
                                this.mainSpinner = false
                            }
                        })
                    } else {
                        FolderApi.Details(data.data_id).then(res => {
                            if (res.data.result) {
                                ff_elem = res.data
                                this.fileDoc = null
                                this.LoadFolder(data.data_id, false)

                            } else {
                                if (res.data.reason == "user_has_no_access") {
                                    this.errorMessage = "You don't have access rights to that folder"
                                }
                            }
                            this.mainSpinner = false
                        })
                    }
                } else {
                    if  (ff_elem.type == 'file') {
                        this.FileViewDetails(ff_elem)
                    } else {
                        this.LoadFolder(data.data_id, false)
                    }
                }
            }
        })

        serverBus.$on(VueSignals.DRAG_DROP_FILE_MENTION, (data) => {
            this.Mention(data.ff_id, data.ff_name, data.ff_type)
        })

        serverBus.$on(VueSignals.SHOW_EXTERNAL_LINK_FOR, (data) => {
            this.ExternalLinks(data.ff_id, data.ff_name, data.ff_type)
        })

        serverBus.$on(VueSignals.ACTIVATED_VIEW, (view) => {
            this.activatedView = view
            if (SessionManager.getActiveChannel().type != 'folder') {
                this.lastActivatedChannelId = SessionManager.getActiveChannelId()
            }
            this.viewFolderContent = []
            if (view == 'Folder') {
                // root folder api call
                this.FolderApiCall(0, this.rootSkip)
                this.tempFolderContent = this.viewFolderContent
                this.viewFolderContent = this.rootFolderContent
                this.activeFolderName = 'root'
                this.activeChannelId = 'root'
                this.folderTreeObjects = [{
                    'cp_id': 'root',
                    'name': 'root'
                }]
            } else if (view == 'Chat') {
                this.viewFolderContent = this.tempFolderContent
                this.activeFolderName = this.ActiveChannelDoc.channel_name
                this.activeChannelId = this.ActiveChannelDoc.channel_id
                this.ListContent(this.activeChannelId, 0, false)
                this.folderTreeObjects = [{
                    'cp_id': this.ActiveChannelDoc.channel_id,
                    'name': this.ActiveChannelDoc.channel_name
                }]
            }

        })

        if (document.querySelector(".right-sidebar-holder") != null && !this.mainSpinner && !this.loading) {
            document.querySelector(".right-sidebar-holder").addEventListener('scroll', this.HandleScroll)
        }

        serverBus.$on(VueSignals.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR, (view) => {
            this.errorMessage = ''
        })


        let ctrlCounter = 0
        /**Bulk operations  */
        serverBus.$on(VueSignals.IS_BULK_OPERATION, (statue) => {
            ctrlCounter++
            this.bulkOperation = statue
            bulkOperation = true
            if (ctrlCounter == 2) {
                ctrlCounter = 0
                this.bulkOperation = false
                bulkOperation = false
            }
        })

        serverBus.$on(VueSignals.BULK_OPERATION, (data) => {
            if (!this.bulkOperationsQueue.some(currElem => {
                    return currElem.ff_id == data.ff_id
                })) {
                this.bulkOperationsQueue.push(data)
                this.bulkSelectedIds.push(data.ff_id)
            } else {
                this.bulkSelectedIds.splice(this.bulkSelectedIds.indexOf(data.ff_id), 1)
                for (let i = 0; i < this.bulkOperationsQueue.length; i++) {
                    if (this.bulkOperationsQueue[i].ff_id == data.ff_id) {
                        this.bulkOperationsQueue.splice(i, 1)
                        break
                    }
                }
            }
        })


        // This is when pressing ctrl, toggle the multiple selections
        // document.body.onkeydown = function(e) {
        //     if ((e.ctrlKey || e.metaKey)) {
        //         Global.globalValue(VueSignals.IS_BULK_OPERATION, true)
        //     }
        // }


        serverBus.$on(VueSignals.OPEN_FILE_IN_BROWSER, (data) => {
            this.OpenBrowser(data.file_id, data.file_name)
        })


        serverBus.$on(VueSignals.MOVE_CONTEXT_MENU, (vertivalMove) => {
            this.moveContextMenu = vertivalMove
        })


    },
    methods: {
        FolderApiCall(skip) {
            FolderApi.getRootfolder(skip).then(res => {
                this.loading = true
                this.mainSpinner = true
                if (res.data.number > 0 && this.activatedView == 'Folder') {
                    this.endOfRootContent = false
                    this.rootSkip += 20
                    // normalize
                    for (let i = 0; i < res.data.roots.length; i++) {
                        res.data.roots[i].type = 'folder'
                        if (!SessionManager.getChannels().some(currChannel => currChannel.channel_id == res.data.roots[i].cp_id)) {
                            if (!this.rootFolderContent.some(elm => {
                                    return elm.cp_id == res.data.roots[i].cp_id
                                })) {
                                res.data.roots[i].hasChannel = false
                                this.rootFolderContent.push(res.data.roots[i])
                            }
                        } else {
                            if (!this.rootFolderContent.some(elm => {
                                    return elm.cp_id == res.data.roots[i].cp_id
                                })) {
                                res.data.roots[i].hasChannel = true
                                this.rootFolderContent.push(res.data.roots[i])
                            }
                        }
                    }
                    if (skip == 0) {
                        document.querySelector(".right-sidebar-holder").scrollTop = 0
                    } else {
                        document.querySelector(".right-sidebar-holder").scrollTop = this.stopPoint
                    }
                } else {
                    this.endOfRootContent = true
                    this.rootSkip = 0
                }
            }).then(res => {
                this.loading = false
                this.mainSpinner = false
            })
        },
        HandleScroll(event) {
            // @TODO move to global
            let container = event.target
            this.scrolledLength = container.scrollHeight - container.clientHeight - container.scrollTop
            this.stopPoint = container.scrollTop
            if (this.scrolledLength < 150 &&
                (this.activatedView == 'Chat' || this.subfolder)) { //(&& !this.activatedView == 'Folder')
                if (!this.loading && !this.endOfContent && this.fileDoc == null) {
                    this.loading = true
                    this.ListContent(this.activeChannelId, this.skip)
                }
            }
            if (this.scrolledLength < 150 &&
                this.activatedView == 'Folder' && this.fileDoc == null) {
                if (!this.loading && !this.endOfRootContent) {
                    this.loading = true
                    this.FolderApiCall(this.rootSkip, false)
                }
            }
        },
        ListContent(id, skip = 0, subfolder = true) {
            if (skip == 0) {
                document.querySelector(".right-sidebar-holder").scrollTop = 0
            } else {
                document.querySelector(".right-sidebar-holder").scrollTop = this.stopPoint
            }

            if (this.bulkOperation) {
                let element = this.viewFolderContent.find(currElem => {
                    return currElem.cp_id == id
                })
                if (typeof element != 'undefined') {
                    this.add_bulk_op(
                        element.cp_id,
                        element.name,
                        element.type
                    )
                    return
                }
            }
            this.mainSpinner = true
            this.loading = true
            if (id == 'root') {
                this.FolderApiCall(0)
            } else {
                FolderApi.listContent(id, skip, 1000, true).then(res => {
                    if (res && typeof res.data.parent_docs != 'undefined') {
                        Global.SetupSubFolder(res.data.parent_docs)
                    }

                    this.subfolder = subfolder
                    let is_root = false
                    if (this.activatedView == "Folder" && !this.subfolder) {
                        is_root = true
                    }
                    if (typeof res.data != 'undefined' && typeof res.data.folder_content != 'undefined' && !is_root) {
                        this.lsError = false
                        this.userRights = res.data.user_rights
                        this.activeFolderName = res.data.folder_name
                        /** @TODO continue checking */
                        if (!subfolder) {
                            if (this.ActiveChannelDoc.channel_id == res.data.folder_id) {
                                if (skip == 0) {
                                    this.viewFolderContent = res.data.folder_content
                                } else {
                                    for (let i = 0; i < res.data.folder_content.length; i++) {
                                        if (typeof res.data.folder_content[i].cp_id != 'undefined' &&
                                            !this.viewFolderContent.some(elm => {
                                                return elm.cp_id == res.data.folder_content[i].cp_id
                                            })) {
                                            this.viewFolderContent.push(res.data.folder_content[i])
                                        }
                                    }
                                }
                                if (!this.folderTreeObjects.some(currObj => {
                                        return currObj.cp_id == res.data.folder_id
                                    })) {
                                    this.folderTreeObjects.push({
                                        'cp_id': res.data.folder_id,
                                        'name': res.data.folder_name,
                                    })
                                    this.subfolder = true
                                }
                            }
                        } else {
                            this.activeChannelId = res.data.folder_id
                            if (skip == 0) {
                                this.viewFolderContent = res.data.folder_content
                            } else {
                                for (let i = 0; i < res.data.folder_content.length; i++) {
                                    if (typeof res.data.folder_content[i].cp_id != 'undefined' &&
                                        !this.viewFolderContent.some(elm => {
                                            return elm.cp_id == res.data.folder_content[i].cp_id
                                        })) {
                                        this.viewFolderContent.push(res.data.folder_content[i])
                                    }
                                }
                            }



                            if (!this.folderTreeObjects.some(currObj => {
                                    return currObj.cp_id == res.data.folder_id
                                })) {
                                this.folderTreeObjects.push({
                                    'cp_id': res.data.folder_id,
                                    'name': res.data.folder_name,
                                })
                                this.subfolder = true
                            }
                        }
                        this.skip += 20

                        if (!this.folderTreeObjects.some(currObj => {
                                return currObj.cp_id == this.activeChannelId
                            })) {
                            this.folderTreeObjects.push({
                                'cp_id': this.activeChannelId,
                                'name': this.activeFolderName,
                            })
                        }

                        if (res.data.folder_content.length == 0) {
                            this.endOfContent = true
                            this.skip = 0
                        } else {
                            this.endOfContent = false
                        }
                        if (this.folderTreeObjects.length == 1) {
                            this.subfolder = false
                        }
                    } else {
                        this.viewFolderContent = [] // because @TODO handle user has no access
                        this.skip = 0
                        if (res.data.reason == "no_storage_node_online") {
                            this.errorMessage = "No online nodes"
                            setTimeout(function() {
                                Global.globalValue(VueSignals.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR, true)
                            }, 3000)
                        }
                    }
                    this.mainSpinner = false
                    this.loading = false

                    for (let i = 0; i < this.viewFolderContent.length; i++) {
                        if (SessionManager.getChannels().some(currChannel => currChannel.channel_id == this.viewFolderContent[i].cp_id)) {
                            this.viewFolderContent[i].hasChannel = true
                        }
                    }
                }, error => {
                    console.error('listContent', error);
                })
            }

        },
        toByte(item) {
            if (item.file_size_b != 0) {
                return Global.toByte(item.file_size_b)
            }
            return Global.toByte(item.file_size_kb_estimate, 1)
        },
        Back() {
            this.skip = 0
            if (this.folderTreeObjects.length != 1) {
                this.folderTreeObjects.splice(-1, 1)
            }
            if (this.folderTreeObjects[this.folderTreeObjects.length - 1].cp_id == "root") {
                this.viewFolderContent = this.rootFolderContent
                this.activeFolderName = 'root'
                this.activeChannelId = 'root'
                this.folderTreeObjects = [{
                    'cp_id': 'root',
                    'name': 'root'
                }]
                this.subfolder = false
            } else {
                this.ListContent(this.folderTreeObjects[this.folderTreeObjects.length - 1].cp_id)
            }
        },
        DownloadFile(file_id, file_name, multi = false) { //@TODO multi
            if (!multi) {
                if (Global.isMobileClientUsed()) {
                    // Xamarin function C#
                    try {
                        window.top.invokeCSharpOpenDocument(this.activeChannelId, file_id, file_name);
                    } catch(err) {
                    }
                } else {
                    FileApi.downloadFile(file_id, file_name, this.activeChannelId).then(res => {
                        if (typeof res.data.link != 'undefined') {
                            let file_path = res.data.link
                            var a = document.createElement('A');
                            a.href = file_path
                            a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                            document.body.appendChild(a);
                            a.click()
                        }
                    })
                }
            } else {
                let filesUrls = []
                for (let i = 0; i < this.bulkOperationsQueue.length; i++) {
                    if (this.bulkOperationsQueue[i].ff_type == 'file') {
                        FileApi.downloadFile(this.bulkOperationsQueue[i].ff_id,
                            this.bulkOperationsQueue[i].ff_name, this.activeChannelId).then(res => {
                            if (res.data.result) {
                                filesUrls.push(res.data.link)
                                if (i == this.bulkOperationsQueue.length - 1) {
                                    for (let j = 0; j < filesUrls.length; j++) {
                                        let file_path = filesUrls[j]
                                        window.open(file_path, "_blank")
                                        if (j == filesUrls.length - 1) {
                                            this.bulkOperation = false
                                            this.bulkOperationsQueue = []
                                            this.bulkSelectedIds = []
                                        }
                                    }
                                }
                            }
                        })
                    } else {
                        this.errorMessage = "currently we don't support download folders"
                        setTimeout(function() {
                            Global.globalValue(VueSignals.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR, true)
                        }, 3000)
                    }
                }
            }
        },
        disableChatMode() {
            KeyboardManager.disableChatMode()
        },
        ShowContextMenu(cp_id) {
            this.ContextMenuBottom = false
            this.ContextMenuTop = false
            if (this.bulkOperation) {
                this.showContextMenu = 'bulkOperation'
                return
            }

            if (this.showContextMenu == cp_id) {
                Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            } else {
                this.showContextMenu = cp_id
                if (document.getElementById(cp_id) != null && document.querySelector('.right-sidebar-holder').clientHeight - document.getElementById(cp_id).offsetTop > 300) {
                    this.ContextMenuTop = true
                } else {
                    this.ContextMenuBottom = true
                }
            }
        },
        CreateNewFolderOverlay() {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            this.createNewFolder = true
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'folder_name')
        },
        createFolder() {
            this.mainSpinner = true
            FolderApi.createSubFolder(this.activeChannelId, this.newFolderName).then(res => {
                if (res.data.result) {
                    this.viewFolderContent.push({
                        "cp_id": res.data.folder_id,
                        "name": this.newFolderName,
                        "type": "folder"
                    })
                } else {
                    if (res.data.reason == "user_cannot_access_node") {
                        this.errorMessage = "You can not access the node"
                        setTimeout(function() {
                            Global.globalValue(VueSignals.REMOVE_ERROR_MESSAGE_RIGHT_SIDEBAR, true)
                        }, 3000)
                    }
                }
                this.newFolderName = ''
                this.createNewFolder = false
                this.mainSpinner = false
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
            })
        },
        RenameOverlay(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'rename_ff')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                'ff_name': ff_name,
                'ff_id': ff_id,
                'ff_type': ff_type
            })
        },
        UploadOverlay(e, ff_id, ff_name, ff_type) {
            let files = e.target.files
            if (files != null) {
                this.showUploadMenu = false
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.UPLOAD_FILE)
                Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                    'ff_name': ff_name,
                    'ff_id': ff_id,
                    'ff_type': ff_type,
                    'files': files
                })
            }
        },
        DeleteOverlay(ff_id, ff_name, multi = false) {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'confirm_delete')
            if (!multi) {
                Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                    'ff_name': ff_name,
                    'ff_id': ff_id
                })
            } else {
                Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, this.bulkOperationsQueue)
                this.bulkOperation = false
                this.bulkOperationsQueue = []
                this.bulkSelectedIds = []
            }
        },
        Delete(ff_id) {
            this.mainSpinner = true
            FolderApi.deleteFF(ff_id, this.activeChannelId).then(res => {
                if (res.data.result) {
                    for (let i = 0; i < this.viewFolderContent.length; i++) {
                        if (this.viewFolderContent[i].cp_id == ff_id) {
                            this.viewFolderContent.splice(i, 1)
                            this.mainSpinner = false
                            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                            break
                        }
                    }
                }
            })

        },
        Rename(data) {
            this.mainSpinner = true
            FolderApi.renameFF(data.ff_id, data.ff_name, this.activeChannelId, data.ff_type).then(res => {
                if (res.data.result) {
                    for (let i = 0; i < this.viewFolderContent.length; i++) {
                        if (this.viewFolderContent[i].cp_id == data.ff_id) {
                            this.viewFolderContent[i].name = data.ff_name
                            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                            break
                        }
                    }
                } else {
                    Global.globalValue(VueSignals.FF_RENAME_ERROR_REASON, res.data.reason)
                    Logging.Debug(res.data.reason)
                }
                this.mainSpinner = false
            })
        },
        Mention(ff_id, ff_name, ff_type, mutli = false) {
            document.getElementById("message_input").focus()
            if (!mutli) {
                Global.globalValue(VueSignals.MENTION_FILE, {
                    "ff_id": ff_id,
                    "ff_name": ff_name,
                    "ff_type": ff_type,
                })
                Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            } else {
                this.bulkOperationsQueue.forEach(currElem => {
                    Global.globalValue(VueSignals.MENTION_FILE, {
                        "ff_id": currElem.ff_id,
                        "ff_name": currElem.ff_name,
                        "ff_type": currElem.ff_type,
                    })
                    Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
                    this.bulkOperation = false
                    this.bulkOperationsQueue = []
                    this.bulkSelectedIds = []
                })
            }
        },
        getFileExtension(filename) {
            return Global.getFileIcon(filename)
        },
        showFileName(id) {
            this.showFileId = id
        },
        ViewOffice(file_id, file_name, folder_id) {
            FileApi.getOffice(file_id, file_name, folder_id).then(res => {
                if (res.data.result) {
                    window.open(res.data.link, '_blank').focus()
                }
            })
        },
        FileViewDetails(file) {
            if (this.bulkOperation) {
                this.add_bulk_op(file.cp_id, file.name, file.type)
                return
            }
            if (document.querySelector(".folder-content .img-preview") != null) {
                document.querySelector(".folder-content .img-preview").outerHTML = ""
            }
            this.fileDoc = file
        },
        getUserName(user_id) {
            if (user_id && user_id != null) {
                return SessionManager.getUser(user_id).username
            }
        },
        LoadFolder(folder, createChannel = false) {
            if (folder.hasChannel) {
                SessionManager.setActiveChannelById(folder.cp_id)
            } else {
                if (createChannel) {
                    let channel = new Channel(folder)
                    SessionManager.setActivePossibleChannel(channel)
                    this.subfolder = true
                } else {
                    this.ListContent(folder)
                }
            }
        },
        LoadFoldeFromDir(folder_id) {
            if (folder_id != 'root') {
                let i = this.folderTreeObjects.length - 1
                while (this.folderTreeObjects[i].cp_id != folder_id &&
                    this.folderTreeObjects.length != 1) {
                    this.folderTreeObjects.splice(-1, 1)
                    i--
                }

                this.LoadFolder(folder_id, false)
            } else {
                this.activeChannelId = 'root'
                this.activeFolderName = 'root'
                this.folderTreeObjects = [{
                    'cp_id': 'root',
                    'name': 'root'
                }]
                this.viewFolderContent = this.rootFolderContent
            }
        },
        ExternalLinks(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.HIDE_CONTEXT_MENU, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, 'external_links')
            Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                'ff_name': ff_name,
                'ff_id': ff_id,
                'ff_type': ff_type,
                'folder_id': this.activeChannelId,
                'user_rights': this.userRights
            })
        },
        SwitchFolderView(view) {
            this.skip = 0
            this.rootSkip = 0
            this.subfolder = false
            if (view == 'Folder') { // chat >> to folder
                Global.globalValue(VueSignals.ACTIVATED_VIEW, 'Folder')
                this.activatedView = view
                this.folderTreeObjects = [{
                    'cp_id': 'root',
                    'name': 'root'
                }]
            }

            if (view == 'Chat') { // folder >> to chat
                Global.globalValue(VueSignals.ACTIVATED_VIEW, 'Chat')
                this.activatedView = view
                this.folderTreeObjects = [{
                    'cp_id': this.ActiveChannelDoc.channel_id,
                    'name': this.ActiveChannelDoc.channel_name
                }]
            }
        },
        getMinTreeObjects() {
            let minTreeArr = []
            let counter = 0
            let charLimit = 60
            for (let i = this.folderTreeObjects.length - 1; i > 0; i--) {
                if (typeof this.folderTreeObjects[i].name != 'undefined') {
                    counter += this.folderTreeObjects[i].name.length + 3
                    if (counter <= charLimit) {
                        minTreeArr.push(this.folderTreeObjects[i])
                    } else {
                        minTreeArr.push({
                            "name": "...",
                            "cp_id": "root"
                        })
                        break
                    }
                }
            }
            if (this.folderTreeObjects.length > 0) {
                minTreeArr.push(this.folderTreeObjects[0])
            }
            return minTreeArr.reverse()
        },
        add_bulk_op(ff_id, ff_name, ff_type) {
            Global.globalValue(VueSignals.BULK_OPERATION, {
                "ff_id": ff_id,
                "ff_name": ff_name,
                "ff_type": ff_type
            })
        },
        ViewCollabora(file_id, name, folder_id) {
            FileApi.downloadFile(file_id, name, folder_id).then(res => {
                if (res.data.result) {
                    FileApi.ViewFile(res.data.token_id).then(res => {
                        if (res.data.result) {
                            this.file_view_src = res.data.link
                            var win = window.open(res.data.link)
                            win.focus()
                        }
                    })
                }
            })
        },
        EditCollabora(file_id, name, folder_id) {
            FileApi.downloadFile(file_id, name, folder_id).then(res => {
                if (res.data.result) {
                    FileApi.EditFile(res.data.token_id).then(res => {
                        if (res.data.result) {
                            var win = window.open(res.data.link)
                            win.focus()
                        }
                    })
                }
            })
        },
        SupportedByBrowser(file_name) {
            if (Global.isMobileClientUsed()) {
                // Don't display in the app
                return false;
            } else {
                for (let i = 0; i < config.SUPPORTED_OPEN_IN_BROWSER.length; i++) {
                    if (file_name.toLowerCase().endsWith(config.SUPPORTED_OPEN_IN_BROWSER[i])) {
                        return true
                    }
                }
                return false
            }
        },
        OpenBrowser(file_id, file_name) {
            FileApi.downloadFile(file_id, file_name, this.activeChannelId, true).then(res => { // true with view
                if (typeof res.data.link != 'undefined') {
                    let file_path = res.data.link
                    var a = document.createElement('A');
                    a.href = file_path
                    a.target = "_blank"
                    a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                    document.body.appendChild(a);
                    a.click()
                }
            })
        },
    }
}
